import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { ProjetoKits } from "src/components/projetos/kits";

const PAGE_TITLE = "Projeto kits";

const ProjetosKitsPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoKits />
        </div>
      </div>
    </div>
  );
};

export { ProjetosKitsPage };
